// extracted by mini-css-extract-plugin
module.exports = {"folder":"TreeNodeItemWrapper__folder--2qeufddQZmOoCm5dY4Xk5K","leaf":"TreeNodeItemWrapper__leaf--3URSmFHj2N4MMBYSFzYlBy"};